var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',{staticClass:"text-black text-6xl font-bold leading-none dark:text-gray-800"},[_vm._v(" BlobsIcons ")])}
var staticRenderFns = []

export { render, staticRenderFns }